import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  button {
    white-space: nowrap !important;
  }
`
export const StyledFiltersOptions = styled(Dropdown)`
font-size: 1.2rem !important;
 .divider.text {
  margin: 0.45238095em 0 0.45238095em -1em !important; 
 }
 .menu.transition {
   margin-left: -6em !important;
    .item {
      padding: 0px !important;
    }
 }

 .ui.checkbox {
   padding : .78571429rem 1.14285714rem !important;
   width: 100%;
 }
`